import React from 'react';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';
import AISvg from 'components/shared/svg/AISvg';
import NoActivitySvg from './svg/NoActivitySvg';

const Finish = () => {
  return (
    <div className="LessonCreationModal-body--initial">
      <div className="mb-8">
        <Text variant={TEXT_VARIANTS.TITLE}>
          <AISvg className="generate-svg" />
          {t('actions.lesson_generate_modal.we_will_take_it')}
        </Text>
      </div>
      <div className="mb-16">
        <Text variant={TEXT_VARIANTS.BODY_LIGHT}>
          {t('actions.lesson_generate_modal.our_ai_is_generating')}
        </Text>
      </div>
      <NoActivitySvg />
    </div>
  );
};

export default Finish;
